import { gql } from '@apollo/client';
import { ADDRESS_FIELDS } from '../address';
import { PAYMENT_FIELDS } from '../payment';
import { STAFF_FIELDS } from './staff.fields';

export const STAFF_DETAIL_FIELDS = gql`
  ${ADDRESS_FIELDS}
  ${STAFF_FIELDS}
  ${PAYMENT_FIELDS}
  fragment StaffDetailFields on Staff {
    ...StaffFields
    manager {
      ...StaffFields
    }
    address {
      ...AddressFields
    }
    payments {
      ...PaymentFields
    }
  }
`;
